import React, { memo } from 'react';
import { css, useTheme } from '@emotion/react';
import { ContainerLayout } from '../../../layouts/ContainerLayout';
import type { ContainerEntryType } from 'tsconfig/types';

export type CmsContainerProps = {
  children: React.ReactNode;
  alignment?: ContainerEntryType['fields']['alignment'];
  backgroundColour?: ContainerEntryType['fields']['backgroundColour'];
  pageWidthToggle?: ContainerEntryType['fields']['pageWidthToggle'];
  fluidWidth?: ContainerEntryType['fields']['fluidWidth'];
};

export const CmsContainer = memo((props: CmsContainerProps) => {
  const { children, backgroundColour, alignment, pageWidthToggle, fluidWidth } = props;
  const theme = useTheme();

  const bgColor = backgroundColour
    ? (theme.colors.bgColors as unknown as Record<string, string>)[backgroundColour]
    : 'initial';

  const container = css`
    ${theme.widgets?.CmsContainer}
    ${backgroundColour && !pageWidthToggle && `background: ${bgColor};`}
    ${backgroundColour && !pageWidthToggle && `background-color: ${backgroundColour};`}
    ${alignment && `text-align: ${alignment.toLowerCase()};`}
  `;
  const fluidWidthStyle = fluidWidth && { padding: '0px' };

  return (
    <div
      data-test="widget-container"
      css={container}
      className={`widget-container ${fluidWidth ? 'fluid-container' : ''}`}
    >
      <ContainerLayout
        fluid={fluidWidth}
        style={{
          background: bgColor,
          backgroundColor: backgroundColour ?? 'initial',
        }}
        css={fluidWidthStyle}
      >
        {children}
      </ContainerLayout>
    </div>
  );
});
